angular.module('stack.common.utility.directive.ngRepeatFinish', [])

/**
 * The nav directive houses the application nav implementation.
 *
 * @class nav
 * @constructor
 * @module stack.common.ui.nav.stacknav
 * @example
 *
 *    <stack-nav
 *      navigation-list="glr.nav"
 *      navigation-type="tabs"
 *      navigation-class="top-nav"
 *      state="glr.state">
 *    </stack-nav>
 */
.directive('ngRepeatFinish', [
  '$timeout',
  function ($timeout) {
    'use strict';

    return {
      restrict: 'A',
      link: function (scope) {
        if (scope.$last === true) {
          $timeout(function () {
            scope.$emit('ngRepeatFinished');
          });
        }
      }
    };
  }
]);
